const audienceDefaultState = {
  audienceId: null,
  audienceName: '',
  audienceEmoji: '',
  audienceQuizTeam: null,
  isAudienceEmojiDisabled: false,
  audienceEmail: '',
  audienceTeam: '',
}

export default audienceDefaultState
